import { render } from "./AsNotifications.vue?vue&type=template&id=5ed71592&ts=true"
import script from "./AsNotifications.vue?vue&type=script&lang=ts"
export * from "./AsNotifications.vue?vue&type=script&lang=ts"

import "./AsNotifications.vue?vue&type=style&index=0&id=5ed71592&lang=scss"

import exportComponent from "/home/gitlab-runner/builds/5c6defa0/0/anyclass/anyclass-frontend/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__